import styled, { css } from "styled-components";
import { Button } from "antd";
import { HexagonItem } from "../H3Map.styles";

export const HexagonContainer = styled.div`
    position: relative;
    margin: 6px 0;
`;

export const HexagonContent = styled.div`
    padding: 8px;
`;

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const HeaderText = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: #262626;
`;

export const HeaderCount = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    background: #f5f5f5;
    padding: 4px 12px;
    border-radius: 16px;
`;

export const CountText = styled.div`
    font-size: 12px;
    color: #8c8c8c;
    font-weight: 500;
`;

export const IconWrapper = styled.div`
    font-size: 12px;
    color: #8c8c8c;
    margin-top: 1px;
`;

export const CompanyCountText = styled.div`
    font-size: 12px;
    color: #40a9ff;
    font-weight: 500;
`;

export const CompanyIconWrapper = styled.div`
    font-size: 10px;
    color: #40a9ff;
`;

export const CompanyContentWrapper = styled.div`
    padding: 4px;
`;

export const ScrollbarStyles = `
    ::-webkit-scrollbar {
        width: 6px;
    }

    ::-webkit-scrollbar-track {
        background: #f5f5f5;
        border-radius: 3px;
    }

    ::-webkit-scrollbar-thumb {
        background: #d9d9d9;
        border-radius: 3px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #bfbfbf;
    }
`;

export const DeleteButton = styled(Button)`
    visibility: hidden;
    height: 24px;
    padding: 0px 8px;
    font-size: 12px;
    transition: none;
    opacity: 0;
    
    ${HexagonItem}:hover & {
        visibility: visible;
        opacity: 1;
    }

    ${({ $isHovered }) => $isHovered && css`
        visibility: visible;
        opacity: 1;
    `}

    &.ant-btn {
        transition: background-color 0.2s ease, color 0.2s ease;
    }
`; 